import { Config } from "./config";

/**
 * Generic function to make a fetch request
 * @param {string} url - The URL to fetch
 * @param {string} method - The HTTP method (GET, POST, PUT, DELETE, etc.)
 * @param {Object} [body] - The body of the request (for POST, PUT, etc.)
 * @param {Object} [headers] - Additional headers for the request
 * @returns {Promise<Object>} - The response data
 */
async function fetchData({
  url,
  method,
  body,
  headers,
  token,
}: any): Promise<any> {
  const options: any = {
    method,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  };

  if (token) {
    options.headers["Authorization"] = `Bearer ${token}`;
  }

  if (body) {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(`${Config.env.app.api_url}/${url}`, options);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
}

export default fetchData;
